export default "/images/ic_warning.svg?d460a7ec7b89f7cf5aa22f6e9734d086";